import * as domHelpers from "../../scripts/utils/domHelpers.js";

class ChooseAttendee {
    constructor() {
        this.wrapHeader();
    }

    wrapHeader() {
        const headerElements = document.querySelector(
            ".spx-fieldset-container__purchase--choose-attendee",
        );

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: "spektrix-page-header",
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(
        ".spx-main-container__purchase--choose-attendee",
    );

    if (pageSelector) {
        new ChooseAttendee();
    }
});
